<video-chapters [chapterInfo]="video.chapterInfo" (onChapterClick)="onChapterClick.emit($event)">
</video-chapters>